// Keyboard, wheel and touch controls.
import { keys, startRide, toOverview } from './ride.js';
import { askReset } from './stop-panel.js';
import { endFinale } from './finale.js';
import { toggleStop } from './stops.js';
import { stickAxes } from '../rules/joystick.js';
import { state } from '../core/state.js';
import { tBoost, tBrake } from '../dom.js';

export let TOUCH, touch;

export function buildInput() {
  addEventListener('keydown', (e) => {
    keys[e.code] = true;
    if (state.mode === 'flyin' || document.getElementById('splash')) return; // the splash handles its own START
    if (document.getElementById('finale').classList.contains('open')) {
      if (e.code === 'Escape') endFinale(false);
      return;
    }
    if (document.getElementById('resetAsk').classList.contains('open')) {
      if (e.code === 'Escape') document.getElementById('resetAsk').classList.remove('open');
      return;
    }
    if (e.code === 'KeyR' && !state.panelOpen) {
      askReset();
      return;
    }
    if (state.mode === 'intro') {
      if (e.code === 'Enter' || e.code === 'Space') startRide();
    } else if (e.code === 'KeyE' || e.code === 'Escape') toggleStop(e.code === 'Escape');
    else if (e.code === 'KeyC' && !state.panelOpen)
      state.mode === 'ride' ? toOverview() : startRide();
    else if (state.mode === 'overview' && /^(KeyW|KeyA|KeyS|KeyD|Arrow)/.test(e.code)) startRide();
    if (e.code.startsWith('Arrow') || e.code === 'Space') e.preventDefault();
  });
  addEventListener('keyup', (e) => (keys[e.code] = false));
  // touch play: an analog joystick (up = throttle, down = brake/reverse, sideways = steer) plus hold-buttons for boost and brake
  TOUCH = matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
  touch = { thr: 0, st: 0, boost: false, brake: false };
  if (TOUCH) document.body.classList.add('touch');
  {
    // The stick appears under the thumb: touching anywhere in the lower left starts it there, so there is no
    // need to hit a small target. It goes back to its resting place on release.
    const zone = document.getElementById('stickZone'),
      stick = document.getElementById('stick'),
      knob = document.getElementById('knob'),
      RAD = 36;
    let id = null,
      cx = 0,
      cy = 0;
    const place = (e) => {
      const half = stick.offsetWidth / 2,
        pad = 8;
      cx = Math.max(half + pad, Math.min(innerWidth - half - pad, e.clientX));
      cy = Math.max(half + pad, Math.min(innerHeight - half - pad, e.clientY));
      stick.style.left = `${cx - half}px`;
      stick.style.bottom = `${innerHeight - (cy + half)}px`;
    };
    const move = (e) => {
      let dx = e.clientX - cx,
        dy = e.clientY - cy;
      const d = Math.hypot(dx, dy);
      if (d > RAD) {
        dx *= RAD / d;
        dy *= RAD / d;
      }
      knob.style.transform = `translate(${dx}px,${dy}px)`;
      const { st, thr } = stickAxes(dx, dy, RAD);
      touch.st = st;
      touch.thr = thr;
    };
    zone.addEventListener('pointerdown', (e) => {
      id = e.pointerId;
      zone.setPointerCapture(id);
      place(e);
      move(e);
      e.preventDefault();
    });
    zone.addEventListener('pointermove', (e) => {
      if (e.pointerId === id) move(e);
    });
    const end = (e) => {
      if (e.pointerId !== id) return;
      id = null;
      touch.thr = touch.st = 0;
      knob.style.transform = '';
      stick.style.left = stick.style.bottom = '';
    };
    zone.addEventListener('pointerup', end);
    zone.addEventListener('pointercancel', end);
    for (const [btn, key] of [
      [tBoost, 'boost'],
      [tBrake, 'brake'],
    ]) {
      const set = (v) => (e) => {
        touch[key] = v;
        btn.classList.toggle('on', v);
        e.preventDefault();
      };
      btn.addEventListener('pointerdown', set(true));
      btn.addEventListener('pointerup', set(false));
      btn.addEventListener('pointercancel', set(false));
      btn.addEventListener('pointerleave', set(false));
    }
    // tapping the "E · place" prompt opens the chapter
    document.getElementById('stopPrompt').addEventListener('click', () => toggleStop(false));
  }
  addEventListener('wheel', (e) => {
    if (state.mode === 'ride')
      state.camDist = Math.min(30, Math.max(6, state.camDist + e.deltaY * 0.01));
  });
}
